import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { isIFrameSameOrigin } from '../shared/helpers/is-same-origin';
import { LocationService } from '../shared/location.service';
import { OeAppPersonService } from '../shared/oe-app-person.service';
import { OeAppService } from '../shared/oe-app.service';
import { ProfileService } from '../shared/profile.service';

const NAVIGATE_TO_PROFILE_EVENT = 'NAVIGATE_TO_PROFILE';

@Component({
  selector: 'lp2-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingHistoryComponent {
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;

  url$ = new Subject();

  constructor(
    private sanitizer: DomSanitizer,
    private oeApp: OeAppService,
    private profileService: ProfileService,
    private oeAppPersonService: OeAppPersonService,
    private locationService: LocationService,
  ) {
    window.addEventListener('message', ({ data, origin }) => {
      if (!isIFrameSameOrigin(this.oeApp.getData('common').ppBillingHistoryUrl, origin)) {
        return;
      }

      if (data.type === NAVIGATE_TO_PROFILE_EVENT) {
        window.location.href = '/account/preferences.html';
      }
    }, false)

    combineLatest([
      this.locationService.getContactPhone(),
      this.profileService.getContactData(),
    ])
    .pipe(
      map(([supportNumber, contact]) => {
        const studentCountry = contact.address.countryISO;
        const studentPhoneNumber = contact.primaryPhone.data || contact.primaryPhone.userEnteredData || '';
        return this.sanitizer.bypassSecurityTrustResourceUrl(
          `${this.oeApp.getData('common').ppBillingHistoryUrl}?lang=${this.oeAppPersonService.preferredLang}&country=${studentCountry}&parentUrl=${window.location.href}&studentPhoneNumber=${studentPhoneNumber}&servicePhoneNumber=${encodeURI(supportNumber)}`
        )
      })
    ).subscribe(url => this.url$.next(url))
  }
}



// WEBPACK FOOTER //
// ./ts/app/billing-history/billing-history.component.ts